<template>
  <v-app>
    <b-row id="discounts" class="section-invert reverse-sm">
      <b-col md="12" lg="6" class="my-auto content">
          <h3>{{ $t('discountssect.title') }}</h3>
            <p class="text-info text-size">{{ $t('discountssect.subtitle') }}</p>
            <!-- <span class="text-info text-size" v-html="$t('discountssect.text')"> -->
            <!-- </span> -->
          <div class="subtitle">
          <div class="subtitle-list subtitle-list mt-sm-5">
            <div>
              <p>
                <v-icon large v-text="'mdi-heart-pulse'"></v-icon>
                {{ $t('discounts.clinic-services') }}
                <v-icon
                  @click.stop="dialog1 = true"
                  v-text="'mdi-chevron-down'"
                ></v-icon>
              </p>
            </div>
            <div>
              <p>
                <v-icon large v-text="'mdi-tooth-outline'"></v-icon>
                {{ $t('discounts.tooth-services')}}
                <v-icon
                  @click="dialog2 = !dialog2"
                  v-text="'mdi-chevron-down'"
                ></v-icon>
              </p>
            </div>
            <div>
              <p>
                <v-icon large v-text="'mdi-spa-outline'"></v-icon>
                {{ $t('discounts.wellness-services')}}
                <v-icon
                  @click="dialog3 = !dialog3"
                  v-text="'mdi-chevron-down'"
                ></v-icon>
              </p>
            </div>
          </div>
        </div>
        <router-link to="/opensaludprime/descuentos">
          <base-button white outline class="mt-5">{{ $t('more-information-btn') }}</base-button>
        </router-link>
      </b-col>
       <b-col :style="$uiHelpers.isTablet ? 'display:none' : ''" md="12" lg="6" class="p-0 p-lg-5">
          <div class="col-bg ml-lg-auto">
          </div>
        </b-col>

      <v-dialog v-model="dialog1" width="auto">
        <v-card>
          <v-card-title class="mt-2">
            {{ $t('discounts.clinic-services-description') }}
          </v-card-title>
          <v-card-text
            >
            <ul class="column_wrapper mt-4">
              <li v-for="(data, i) in medical_services" :key="i">
                {{ data }}
              </li>
            </ul>
          </v-card-text>
             <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog1 = false"
          >
            {{ $t('discounts.close')}}
          </v-btn>
        </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog2">
        <v-card>
          <v-card-title class="mt-2">
            {{ $t('discounts.teeth-services-description') }}
          </v-card-title>
          <v-card-text>
            <ul class="column_wrapper mt-4">
              <li v-for="(data, i) in teeth_services" :key="i">
                {{ data }}
              </li>
            </ul>
          </v-card-text>
           <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog2 = false"
          >
            {{ $t('discounts.close')}}
          </v-btn>
        </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog3">
        <v-card>
          <v-card-title class="mt-2">
            {{ $t('discounts.health-services-description') }}
          </v-card-title>
          <v-card-text
            >
            <ul class="column_wrapper">
              <li v-for="(data, i) in health_services" :key="i">
                {{ data }}
              </li>
            </ul>
          </v-card-text>
           <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog3 = false"
          >
            {{ $t('discounts.close')}}
          </v-btn>
        </v-card-actions>
        </v-card>
      </v-dialog>
    </b-row>
  </v-app>
</template>

<script>
import 'vuetify/dist/vuetify.min.css'

/*eslint-disable */
export default {
  data() {
    const medical_services = this.$t('discounts.medical-services-list').split('<br>')
    const teeth_services = this.$t('discounts.teeth-services-list').split('<br>')
    const health_services = this.$t('discounts.health-services-list').split('<br>')
    return {
      dialog1: false,
      dialog2: false,
      dialog3: false,
      medical_services: medical_services,
      teeth_services: teeth_services,
      health_services: health_services
    };
  },
};
</script>

<style lang="scss">
 // Black section with full column image
.v-application--wrap {
    min-height: fit-content;
  }
.section-invert {
  @include section;
  background-color: $black;

  h3 {
    color: $white;
  }

  .content {
    @include container-padding;

    @include desktop {
      padding: {
        top: 4rem;
        bottom: 4rem;
      }
    }

  }
.text-size {
  @include desktop(){
    font-size: 1.25rem;
  }
}
  .subtitle {
    @include desktop-sm {
      width: 100% !important;
    }

    p {
      color: $gray;
    }

    span {
      color: $gray
    }
    .subtitle-list {
      &.subtitle-list-large {
        p {
          color: $white;
          margin-top: 0 !important;
          margin-bottom: 0 !important;
        }
      }
      &:not(.subtitle-list-large) {
        span {
          color: $white;
        }
      }
      span {
        font-size: 1.25rem;
        display: inline-block;
      }
      > div {
        margin-bottom: 1rem;
        color: $white;
        > span {
          font-size: 1.5rem;
        }
      }

      .v-icon {
        color: $gray;
        margin-right: 1rem;
      }
    }
  }

  .col-bg {
    width: 100%;
  }
}
.column_wrapper {
  column-count: 3;
}

#discounts {
  @include media(tablets, mobile) {
    flex-direction: column-reverse;
  }
  .col-bg {
    background-blend-mode: overlay;
    background-image: url('/static-appopensalud/img/bgs/discounts.jpg'),  linear-gradient(
      180deg, #E4E4E455, #E4E4E4ff);
    background-position-y: center;
  }
}
@import "static-appopensalud/css/public/layout.scss";

.medicos,
.bienestar {
  display: flex;
}
.v-dialog--active .v-card__title {
  color: #3238C4;
  justify-content: center;
  word-break:break-word;
}
.v-dialog__content .v-dialog--active .v-card__text ul li {
  margin-top: 5px;
}
@media (max-width: 1268px) {
  #discounts > div.content.my-auto.col-md-12.col-lg-6 > div > div > div > p {
    font-size: 1rem;
  }
}
@media (max-width: 960px) {
  .v-dialog__content .v-dialog--active {
    width: 85vw;
  }
  .medicos,
  .bienestar {
    display: block;
  }
  #wellness div.col-md-12:first-child{
    order: 2;
  }
  .column_wrapper{
    column-count: 1;
  }
  #discounts .subtitle{
    width: 100%;
  }
}
@media (max-width: 960px) and (orientation: landscape) {
  .column_wrapper{
    column-count: 3;
  }
}

@media (max-width: 1024px) {
  #wellness div.col-md-12:first-child{
    order: 2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/opensalud/OpenSaludDiscountsBusiness.vue